import { Component, OnInit } from '@angular/core';
import { EmailLogsService } from '../services/email-logs.service';
import { EmailLogsParams } from '../app.model';
import { DataSharedService } from '../services/data-shared.service';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EmailLogDetailComponent } from '../components/email-log-detail/email-log-detail.component';
import * as moment from 'moment';


@Component({
  selector: 'app-email-logs',
  templateUrl: './email-logs.component.html',
  styleUrls: ['./email-logs.component.css']
})
export class EmailLogsComponent implements OnInit {


  public loading: boolean = false;
  public emailLogs: any = [];
  totalCount: number = 0;
  private modalRef: NgbModalRef;
  emailLogSearch: string = '';
  selectedMonth: string | null = null;
  selectedYear: number | null = null;
  years: number[] = [];
  months: any[] = [];

  constructor(public emailLogService: EmailLogsService,
    public dataSharedService: DataSharedService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    const now = moment();
    this.months = this.dataSharedService.getMonths();
    this.years = this.dataSharedService.getYears();
    this.selectedMonth = now.format('MM'); // Default to current month
    this.selectedYear = +now.format('YYYY'); // Default to current year
    this.getEmailLogs(1);
  }

  getEmailLogs(page: number, search?: string) {
    const params: EmailLogsParams = {
      limit: 20,
      page,
      search: search,
      month: this.selectedMonth,
      year: this.selectedYear
    };

    this.emailLogService.getEmailLogs(page, params).subscribe((emailLogs: any) => {
      this.loading = false;
      this.emailLogs = emailLogs.data;
      this.totalCount = emailLogs.meta.total;
    });
  }

  onStepChange(event: any) {
    this.getEmailLogs(event)
  }

  searchEmaiLog() {
    if (this.emailLogSearch != '') {
      this.getEmailLogs(1, this.emailLogSearch);
    } else {
      this.getEmailLogs(1);
    }
  }

  viewEmailLog(emailLog: any) {
    this.modalRef = this.modalService.open(EmailLogDetailComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: "static",
      modalDialogClass: 'update-client-modal',
    });
    this.modalRef.componentInstance.to = emailLog.to;
    this.modalRef.componentInstance.email_body = emailLog.body_html;
    this.modalRef.componentInstance.subject = emailLog.subject;
  }

}
